import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  DeletePO,
  GetPOById,
  GetProformaByProject,
  MakeInvoice,
  SendPO,
  addClientPO,
} from "../../redux/actions/proformaAction";
import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";
import CardAddButton from "../../assets/icons/CardAddButton.svg";
import Xcircle from "../../assets/icons/x-circle.svg";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import MonetizationOnOutlined from "@mui/icons-material/MonetizationOnOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const Proforma = () => {
  const history = useHistory();
  const projectId = window.localStorage.getItem("projectid");
  const [proformaList, setProformaList] = useState([]);
  const [openBurgerMenu, setBurgerMenu] = useState(false);
  const [spinner, setSpinner] = useState(true);
  const [emailPopup, setEmailPopup] = useState(false);
  const [typeEmail, setTypeEmail] = useState("");

  const [menuStates, setMenuStates] = useState(
    Array(proformaList.length).fill(false),
  );

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Add-Project").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const [hoveredIndex, setHoveredIndex] = useState(null);

  const toggleMenu = (index) => {
    setMenuStates((prevMenuStates) => {
      if (prevMenuStates[index]) {
        return Array(prevMenuStates.length).fill(false);
      }
      const newMenuStates = Array(prevMenuStates.length).fill(false);
      newMenuStates[index] = !prevMenuStates[index];
      return newMenuStates;
    });
  };

  useEffect(() => {
    getProformaByProjectId();
  }, []);

  const getProformaByProjectId = async () => {
    if (projectId) {
      var result = await GetProformaByProject(projectId);
      setProformaList(result);
      setTotalItems(result?.length || 0);
      setTotalPages(Math.ceil((result?.length || 0) / itemsPerPage));
    }
    setSpinner(false);
  };

  const handleSend = async (poId) => {
    let data = {
      PerformanceVoucherId: poId,
      ClientEmail: typeEmail,
    };
    var result = await SendPO(data);
    getProformaByProjectId();
  };

  const handleMakeInvoice = async (poId) => {
    var result = await MakeInvoice(poId);
    getProformaByProjectId();
  };
  const [showSuccessToast, setShowSuccessToast] = useState(false);

  const handleDelete = async (poId) => {
    var result = await DeletePO(poId);
    getProformaByProjectId();
    setMenuStates(Array(proformaList.length).fill(false));
    if (result === true) {
      setShowSuccessToast(true);

      setTimeout(() => {
        setShowSuccessToast(false);
      }, 5000);
    }
  };

  const formatDate = (dateString) => {
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    const formattedDate = new Date(dateString).toLocaleDateString(
      "en-GB",
      options,
    );
    return formattedDate;
  };

  const [inputTextArray, setInputTextArray] = useState(
    Array(proformaList.length).fill(""),
  );

  const handleChange = (event, index) => {
    const newInputTextArray = [...inputTextArray];
    newInputTextArray[index] = event.target.value;
    setInputTextArray(newInputTextArray);
  };

  const handleBlur = async (poId, index) => {
    const currentInputText = inputTextArray[index].trim();
    if (currentInputText !== "") {
      var data = {
        performaVoucherId: poId,
        clientPoNumber: currentInputText,
      };
      var result = await addClientPO(data);
    }
  };

  const handleAddProforma = () => {
    var data = {
      action: "project",
      project: {
        projectId: window.localStorage.getItem("projectid"),
        projectname: window.localStorage.getItem("projectname"),
      },
      client: {
        clientId: window.localStorage.getItem("clientid"),
        contactname: window.localStorage.getItem("clientname"),
        clientEmail: window.localStorage.getItem("clientEmail"),
      },
    };
    history.push("/request-po", data);
  };

  const handleEditPO = (poId) => {
    GetPOById(poId).then((result) => {
      let data = {
        action: "edit",
        project: { projectId: result[0]?.projectId, projectName: "" },
        client: { clientId: result[0]?.clientId, clientName: "" },
        poResult: result,
      };
      history.push("/request-po", data);
    });
  };

  const handleEmailChange = (event) => {
    setTypeEmail(event.target.value);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);

  return (
    <>
      {showSuccessToast && (
        <Alert
          style={{ position: "fixed", top: "35px", right: "45px", zIndex: "1" }}
          severity="success"
          color="info"
        >
          Proforma deleted successfully...
        </Alert>
      )}
      {spinner ? (
        <Box>
          <Skeleton />
          <Skeleton animation="wave" />
        </Box>
      ) : (
        <div
          style={{
            margin: "0",
            padding: "20px",
            background: "white",
            overflow: "auto",
          }}
        >
          <div className="d-flex gap-5 align-items-center">
            <section
              className="d-flex gap-2 pointer"
              onClick={() => {
                handleAddProforma();
              }}
            >
              <img src={CardAddButton} className="addDocImg" alt="Add Icon" />
              <p className="addDocText">
                {/* Add Proforma */}
                {t("Add Proformas")}
              </p>
            </section>

            <section
              className="fr quotes-div-sec-2 addstock-page-length  addstock-page-in-tablet ms-auto"
              style={{ gap: "7px" }}
            >
              <p>
                {pageNumber === 1 ? 1 : itemsPerPage * (pageNumber - 1) + 1}-
                {itemsPerPage * pageNumber > totalItems
                  ? totalItems
                  : itemsPerPage * pageNumber}
              </p>
              <p>of</p>
              <p>{totalItems}</p>
              <p
                className="aro-lr"
                onClick={() => {
                  if (pageNumber === 1) return;
                  setPageNumber((p) => p - 1);
                }}
              >
                {"<"}
              </p>
              <p className="quote-current-page">{pageNumber}</p>
              <p
                className="aro-lr"
                onClick={() => {
                  if (pageNumber >= totalPages) return;
                  setPageNumber((p) => p + 1);
                }}
              >
                {">"}
              </p>
            </section>
          </div>

          <div>
            <table>
              <thead>
                <tr className="accordian-summary-heading-div">
                  <th>
                    {/* Request ID */}
                    {t("Request Id")}
                  </th>
                  <th>
                    {/* Work Order */}
                    {t("Work Order")}
                  </th>
                  <th>
                    {/* Date */}
                    {t("Date")}
                  </th>
                  <th>
                    {/* Total Amount */}
                    {t("Total Amount ")}
                  </th>
                  <th>
                    {/* Client PO no. */}
                    {t("Client PO No.")}
                  </th>
                  <th>
                    {/* Status */}
                    {t("Status")}
                  </th>
                </tr>
              </thead>
              <tbody>
                <React.Fragment>
                  {proformaList
                    ?.slice(
                      (pageNumber - 1) * itemsPerPage,
                      pageNumber * itemsPerPage,
                    )
                    .map((po, index) =>
                      po.status && po.status.toLowerCase() !== "deleted" ? (
                        <tr
                          className="accordian-summary-heading-div"
                          style={{ position: "relative" }}
                        >
                          <td
                            className="performa-id"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              handleEditPO(po.performaVoucherId);
                            }}
                            onMouseEnter={() => setHoveredIndex(index)}
                            onMouseLeave={() => setHoveredIndex(null)}
                          >
                            {po.requestId}{" "}
                            {/* {hoveredIndex === index && <PictureAsPdfIcon />} */}
                          </td>
                          <td>{po.workOrder}</td>
                          <td>{formatDate(po.requestedDate)}</td>
                          <td>{po.totalAmount}</td>
                          {po.clientPONumber != null &&
                          po.clientPONumber.length > 0 ? (
                            <td>{po.clientPONumber}</td>
                          ) : (
                            <td>
                              <input
                                style={{
                                  border: "none",
                                  background: "#FAFAFA",
                                }}
                                type="text"
                                value={inputTextArray[index]}
                                onChange={(e) => handleChange(e, index)}
                                onKeyDown={() => {
                                  handleBlur(po.performaVoucherId, index);
                                }}
                                onBlur={() => {
                                  handleBlur(po.performaVoucherId, index);
                                }}
                              />
                            </td>
                          )}
                          <td
                            className={
                              po.status &&
                              po.status.toLowerCase() === "not sent"
                                ? "label-orange"
                                : ""
                            }
                          >
                            {po.status}
                          </td>
                          <td
                            style={{
                              display: "flex",
                              gap: "10px",
                              height: "45px",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              toggleMenu(index);
                              setEmailPopup(false);
                            }}
                          >
                            <MoreVertRoundedIcon />
                          </td>
                          {menuStates[index] && (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                fontSize: "14px",
                                width: "200px",
                                padding: "20px",
                                gap: "10px",
                                borderRadius: "5px",
                                boxShadow: "-3px 3px 6px 0px #bdbdbd",
                                position: "absolute",
                                right: "23px",
                                zIndex: "1",
                                background: "white",
                                top: "37px",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  gap: "5px",
                                  alignItems: "center",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setEmailPopup(!emailPopup);
                                  // setTypeEmail(po.cleintEmailAddress);
                                }}
                              >
                                <SendOutlinedIcon />
                                <p style={{ margin: "0" }}>Send</p>
                              </div>
                              {emailPopup && (
                                <div
                                  className="email-popup-proforma"
                                  style={{ justifyContent: "unset" }}
                                >
                                  <img
                                    src={Xcircle}
                                    alt="close popup"
                                    className="ms-auto pointer"
                                    style={{ width: "18px" }}
                                    onClick={() => {
                                      setEmailPopup(false);
                                      // setShowLoader(false);
                                    }}
                                  />
                                  <TextField
                                    id="outlined-basic"
                                    label="Client Email"
                                    variant="outlined"
                                    style={{
                                      color: "#5B5B5B",
                                      borderColor: "#5B5B5B",
                                      borderRadius: "8px",
                                      width: "100%",
                                    }}
                                    //   value={po.cleintEmailAddress}
                                    value={typeEmail}
                                    onChange={handleEmailChange}
                                  />
                                  <p
                                    className="m-0 task-modal-cancel-btn1-pop me-3"
                                    style={{
                                      background: "#D2DCE9",
                                      color: "#00246A",
                                      height: "50px",
                                    }}
                                    onClick={() => {
                                      handleSend(po.performaVoucherId);
                                      setEmailPopup(false);

                                      setTimeout(() => {
                                        setTypeEmail("");
                                      }, 2000);
                                    }}
                                  >
                                    Send
                                  </p>
                                </div>
                              )}
                              <div
                                style={{
                                  display: "flex",
                                  gap: "5px",
                                  alignItems: "center",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  handleMakeInvoice(po.performaVoucherId);
                                }}
                              >
                                <MonetizationOnOutlined />
                                <p style={{ margin: "0" }}>Make Invoice</p>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  gap: "5px",
                                  alignItems: "center",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  handleDelete(po.performaVoucherId);
                                }}
                              >
                                <DeleteIcon />
                                <p style={{ margin: "0" }}>Delete</p>
                              </div>
                            </div>
                          )}
                        </tr>
                      ) : (
                        <tr
                          className="accordian-summary-heading-div color-gray"
                          style={{ position: "relative" }}
                        >
                          <td className="" style={{ cursor: "pointer" }}>
                            {po.requestId}{" "}
                            {/* {hoveredIndex === index && <PictureAsPdfIcon />} */}
                          </td>
                          <td>{po.workOrder}</td>
                          <td>{formatDate(po.requestedDate)}</td>
                          <td>{po.totalAmount}</td>
                          <td>{po.clientPONumber}</td>
                          <td>{po.status}</td>
                          <td
                            style={{
                              display: "flex",
                              gap: "10px",
                              height: "45px",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                          >
                            <MoreVertRoundedIcon />
                          </td>
                        </tr>
                      ),
                    )}
                  {proformaList.length === 0 && (
                    <span className="noDataDisplay">
                      {/* No data to display! */}
                      {t("No data to display!\n")}
                    </span>
                  )}
                </React.Fragment>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
};

export default Proforma;
